import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    .section {
      padding: 25px 40px;
      margin-bottom: 100px;
    }
    .header-choose {
      height: 75px;
      background-color: rgba(236, 255, 184, 1);
      padding-left: 60px;
      display: flex;
      align-items: center;
    }
    .add-statement {
      margin-top: 20px;
      background-color: #f6f6f6;
      border-radius: 10px;
      .text {
        padding: 10px 0px 10px 20px;
        border-bottom: 2px solid white;
      }
      .form-add {
        padding: 30px 0px 20px 20px;
      }
      .btn-add {
        font-size: 14px;
        width: 64px;
        border: none;
        background-color: #ff8a00;
        color: white;
      }
      .label-select {
        margin-bottom: 1px;
      }
      .btn-sbm {
        margin-top: 22px;
      }
    }
    .confirm-step {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .btn-save {
      background-color: #ff8a00;
      border-radius: 4px;
      color: white;
      border: none;
      width: 240px;
      height: 60px;
    }
    .btn-cancel-save {
      width: 112px;
      height: 60px;
      background-color: #c4c4c4;
      border-radius: 4px;
      border: none;
      color: white;
      margin-right: 10px;
    }
    .table-data-user {
      margin-top: 15px;
    }
    .table {
      margin-top: 40px;
    }
  }
`;
